import { lazy } from 'react';

export { Edit, Create } from './form';
export { ListPage as List } from './list';

const Details = lazy(() => import('./details'));

export { Details };
